import React from 'react';

import Tooltip from '@mui/material/Tooltip';

import './styles.scss';

const OlcTooltip = ({
  arrow = true,
  children,
  classes = {},
  disableInteractive = true,
  enterDelay = 300,
  placement = 'top',
  title,
  ...tooltipProps
}) => {
  if (!title) return children;

  return (
    <Tooltip
      {...tooltipProps}
      arrow={arrow}
      classes={{
        ...classes,
        arrow: ['olcTooltip__arrow', classes.arrow].filter(Boolean).join(' '),
        tooltip: ['olcTooltip__content', classes.tooltip].filter(Boolean).join(' '),
      }}
      disableInteractive={disableInteractive}
      enterDelay={enterDelay}
      placement={placement}
      title={title}
    >
      {children}
    </Tooltip>
  );
};

export default OlcTooltip;
